@if (modalConfirmationDeleteInputCodeService.showModal()) {
  <div
    class="fixed inset-0 bg-gray-900/50 flex items-center justify-center z-50"
    >
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-lg">
      <div class="text-center">
        <h3 class="text-lg font-medium text-gray-900 mb-4">
          Ingresa el código  que llegó a tu correo  para confirmar la eliminacion de tu
          cuenta
        </h3>
        <div class="bg-white p-4 rounded-lg shadow mb-6">
          <div class="flex flex-col items-center justify-center">
            <form [formGroup]="form" class="w-full">
              <div class="flex justify-center gap-2 mb-4">
                <input
                  type="text"
                  maxlength="1"
                  class="w-12 h-12 text-center text-xl font-bold border-2 border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors duration-200"
                  #code1
                  (keyup)="onCodeInput($event, code1, code2)"
                  (paste)="onPaste($event)"
                  >
                  <input
                    type="text"
                    maxlength="1"
                    class="w-12 h-12 text-center text-xl font-bold border-2 border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors duration-200"
                    #code2
                    (keyup)="onCodeInput($event, code2, code3)"
                    >
                    <input
                      type="text"
                      maxlength="1"
                      class="w-12 h-12 text-center text-xl font-bold border-2 border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors duration-200"
                      #code3
                      (keyup)="onCodeInput($event, code3, code4)"
                      >
                      <input
                        type="text"
                        maxlength="1"
                        class="w-12 h-12 text-center text-xl font-bold border-2 border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors duration-200"
                        #code4
                        (keyup)="onCodeInput($event, code4, code5)"
                        >
                        <input
                          type="text"
                          maxlength="1"
                          class="w-12 h-12 text-center text-xl font-bold border-2 border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors duration-200"
                          #code5
                          (keyup)="onCodeInput($event, code5, code6)"
                          >
                          <input
                            type="text"
                            maxlength="1"
                            class="w-12 h-12 text-center text-xl font-bold border-2 border-amber-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors duration-200"
                            #code6
                            (keyup)="onCodeInput($event, code6, null)"
                            >
                          </div>
                          <input type="hidden" formControlName="codeDelete">
                          <button
                            type="submit"
                            (click)="onSubmit()"
                            class="w-full py-3 px-4 bg-red-500 text-white rounded-md shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-colors duration-200 font-medium"
                            >
                            Confirmar
                          </button>
                        </form>
                      </div>
                    </div>
                    <p class="text-gray-600 mb-6">
                      ¿Estás seguro que deseas eliminar tu cuenta? Esta acción no se puede
                      deshacer.
                    </p>
                    <div class="flex justify-center gap-4">
                      <button
                        (click)="closeModal()"
                        class="p-3 bg-gray-200 text-gray-800 rounded-full hover:bg-gray-300 transition duration-200 flex items-center justify-center"
                        aria-label="Cancelar"
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
